import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from '@apollo/client/react/hoc';
import { Mutation } from '@apollo/client/react/components';
import { Message } from 'semantic-ui-react';

import { fileImport } from 'GraphQL/LE/mutation/FileImport.mutation';
import { fileImportJobs } from 'GraphQL/LE/query/FileImport.query';
import CheckCloseComponent from 'Util/CheckDefinedComponent';

import { FILE_TYPE } from '../../common';

import DataForm from './DataForm';

class NewDataMutation extends Component {
  static propTypes = {
    onComplete: PropTypes.func,
    priceId: PropTypes.string,
    type: PropTypes.oneOf(Object.values(FILE_TYPE)).isRequired,
  };

  static defaultProps = {
    onComplete: () => {},
  };

  constructor(props) {
    super(props);
  }

  convertFormValue = (form) => {
    const data = {
      type: this.props.type,
      ...form,
      // TODO: When you have import FILE, uncomment these line
      // originalFilename: form.file.originalFilename,
      // file: {
      //   key: form.file.key,
      //   bucket: form.file.bucket,
      // },
    };
    return data;
  };

  render() {
    const { variables, type } = this.props;
    return (
      <Mutation mutation={fileImport} refetchQueries={[{ query: fileImportJobs, variables }]}>
        {(createData, { loading, error, data }) => {
          return (
            <Fragment>
              {error && <Message negative>{JSON.stringify(error.message)}</Message>}
              <CheckCloseComponent checkDefinedObject={data} onDefined={this.props.onComplete} />
              <DataForm
                type={type}
                onCreateNewData={(form) =>
                  createData({ variables: { input: this.convertFormValue(form) } })
                }
                loading={loading}
                showCancel
                onCancelled={this.props.onCancelled}
                {...this.props}
              />
            </Fragment>
          );
        }}
      </Mutation>
    );
  }
}

export default withApollo(NewDataMutation);
